import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.4",
        d: "m6.667 10-2.05 2.076c-.286.29-.43.434-.552.444a.33.33 0 0 1-.28-.115c-.081-.093-.081-.297-.081-.704v-1.04c0-.365-.3-.63-.66-.682a2 2 0 0 1-1.69-1.69c-.02-.143-.02-.315-.02-.66V4.534c0-1.12 0-1.68.217-2.108a2 2 0 0 1 .875-.874c.427-.218.987-.218 2.108-.218h4.933c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.428.218.988.218 2.108v2.8m0 7.334-1.451-1.009c-.204-.142-.306-.213-.417-.263a1.3 1.3 0 0 0-.308-.097c-.12-.022-.245-.022-.493-.022H8.8c-.747 0-1.12 0-1.405-.145a1.33 1.33 0 0 1-.583-.583c-.145-.285-.145-.658-.145-1.405V9.467c0-.747 0-1.12.145-1.406.128-.25.332-.454.583-.582.285-.146.658-.146 1.405-.146h3.733c.747 0 1.12 0 1.406.146.25.128.455.332.582.582.146.286.146.659.146 1.406v1.81c0 .62 0 .931-.102 1.176a1.33 1.33 0 0 1-.721.722c-.245.101-.556.101-1.177.101z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }